// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__8HFeu","itemTitle":"ClientEmergencyInfo_itemTitle__1BGLR","itemText":"ClientEmergencyInfo_itemText__1Fdyv"};